import React from "react";
import { Youtube, Instagram } from "@icons-pack/react-simple-icons";

function Socials() {
  const iconSize = 40;

  return (
    <ul className="socials-list">
      <li>
        <a href="https://www.youtube.com/channel/UCwsJHHxjpxJZ0JVF1vV5VBQ">
          <Youtube className="social-icon" color="#FFFFFF" size={iconSize} />
        </a>
      </li>
      <li>
        <a href="https://www.instagram.com/ocean.carlisle/">
          <Instagram className="social-icon" color="#FFFFFF" size={iconSize} />
        </a>
      </li>
    </ul>
  );
}

export default Socials;
